export interface CarrierServiceTypeData {
  carrierServiceTypeId: number;
  carrierId: string;
  serviceTypeId: number;
  serviceTypeName: string;
  isDeleted: boolean;
  lastChgDtTm: Date;
  deleteDtTm: Date;
}
